import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gob-tournaments',
  templateUrl: './tournaments.component.html',
  styleUrls: ['./tournaments.component.scss']
})
export class TournamentsComponent implements OnInit {

  // Données statiques (Thème Vert - JCC)
  jeux = [
    { 
      nom: 'Yu-Gi-Oh!', 
      logo: 'assets/img/logos/yugioh.png', 
      img: 'assets/img/jcc/yugioh.png', 
      desc: 'Tournois Locaux', 
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/yu-gi-ho'] 
    },
    { 
      nom: 'Magic', 
      logo: 'assets/img/logos/magic.png', 
      img: 'assets/img/jcc/magic.png', 
      desc: 'FNM & Avant-premières', 
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/magic'] 
    },
    { 
      nom: 'Pokémon', 
      logo: 'assets/img/logos/pokemon.png', 
      img: 'assets/img/jcc/pokemon.png', 
      desc: 'Ligues & Cups', 
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/pokemon'] 
    },
    { 
      nom: 'RiftBound', 
      logo: 'assets/img/logos/riftbound.png', 
      img: 'assets/img/jcc/riftbound.png', 
      desc: 'Unlimited', 
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/riftbound'] 
    },
    { 
      nom: 'Lorcana', 
      logo: 'assets/img/logos/lorcana.png', 
      img: 'assets/img/jcc/lorcana.png', 
      desc: 'Tournois & Ligues', 
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/lorcana'] 
    },
    { 
      nom: 'Autres Tournois', 
      logo: 'assets/img/logos/autrejcc.png', 
      img: 'assets/img/jcc/autresJcc.png', 
      desc: 'Tout nos autres tournois jcc', 
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/toutes'] 
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}